import React from 'react';
import { navigate } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Hits } from 'react-instantsearch-dom';
import styled from 'styled-components';
import {
  minBreakpointQuery,
  standardColours,
  fontWeights,
  fontSize,
  zIndexLayers,
} from '../styles';
import { Link } from './ui';
import { ProductPrice } from './Prices';
import { buildUrl } from '../utils';

const StyledSearchResult = styled.div`
  position: absolute;
  z-index: ${zIndexLayers.fourth};
  left: 0;
  display: ${({ show }) => (show ? `block` : `none`)};
  width: 100%;
  background-color: ${standardColours.white};
  border: 1px solid ${standardColours.lightGrey};
`;

const StyledItem = styled.div`
  display: flex;
  align-items: center;
  margin: 20px;
  cursor: pointer;
`;

const StyledImage = styled(GatsbyImage)`
  min-width: 40px;
  max-width: 40px;

  ${minBreakpointQuery.small`
    min-width: 55px;
    max-width: 55px;
  `}

  ${minBreakpointQuery.large`
    min-width: 70px;
    max-width: 70px;
  `}
`;

const StyledContent = styled.div`
  margin-left: 18px;
`;

const StyledName = styled.p`
  color: ${standardColours.black};
  font-weight: ${fontWeights.semibold};
  ${fontSize(16)};

  ${minBreakpointQuery.large`
    ${fontSize(17)};
  `}
`;

const StyledPrice = styled(ProductPrice)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
`;

const PageHit = ({
  hit: {
    title,
    handle,
    featuredImage: { gatsbyImageData, altText },
    priceRangeV2,
    variants,
    isRetailProduct,
  },
}) => (
  <StyledItem
    onClick={() => {
      navigate(buildUrl(handle));
    }}
  >
    <StyledImage image={gatsbyImageData} alt={altText || title} />
    <StyledContent>
      <StyledName>
        <Link to={handle}>{title}</Link>
      </StyledName>
      <StyledPrice
        priceRangeV2={priceRangeV2}
        variants={variants}
        isSearchItem={true}
        isRetailProduct={isRetailProduct && JSON.parse(isRetailProduct.value)}
      />
    </StyledContent>
  </StyledItem>
);

const SearchResult = ({ show }) => (
  <StyledSearchResult show={show}>
    <Hits hitComponent={PageHit} />
  </StyledSearchResult>
);

export default SearchResult;
